<template>
	<div class='address-picker-block'>

		<div class='grid'>

			<span class='label'>Федеральный округ</span>
			<custom-p-select
				v-model='selectedFo'
				:options='foList'
				:loading='loadingFoList'
				:disabled='loadingFoList'
			/>

			<span class='label'>Субъект РФ</span>
			<custom-p-select
				v-model='selectedRegion'
				:options='regionList'
				:loading='loadingRegionList'
				:disabled='loadingRegionList || !selectedFo'
			/>

			<span class='label'>Лесничество</span>
			<custom-p-select
				v-model='selectedForestry'
				:options='forestryList'
				:loading='loadingForestryList'
				:disabled='loadingForestryList || !selectedRegion'
			/>

			<span class='label'>Участковое лесничество</span>
			<custom-p-select
				v-model='selectedLocalforestry'
				:options='localforestryList'
				:loading='loadingLocalforestryList'
				:disabled='loadingLocalforestryList || !selectedForestry'
			/>

			<span class='label'>Урочище / дача</span>
			<custom-p-select
				v-model='selectedSubforestry'
				:options='subforestryList'
				:loading='loadingSubforestryList'
				:disabled='loadingSubforestryList || !selectedLocalforestry'
			/>

			<span class='label'>Квартал</span>
			<custom-p-select
				v-model='selectedArea'
				:options='areaList'
				:loading='loadingAreaList'
				:disabled='loadingAreaList || !selectedSubforestry'
			/>

			<template v-if='selectedArea'>
				<div></div>
				<span  @click='linkToTax' class='linkToTax'>Нет выдела в списке? Введите таксационное описание этого выдела</span>
			</template>

			<span class='label'>Выдел</span>
			<custom-p-select
				v-model='selectedSection'
				:options='sectionList'
				:loading='loadingSectionList'
				:disabled='loadingSectionList || !selectedArea'
			/>

			

			<label for='id_section_lp_exists'>
				<span class='label'>Лесопатологический выдел</span>
			</label>
			<div>
				<custom-p-checkbox v-model='sectionLpExists' :disabled='!selectedSection' checkbox-id='id_section_lp_exists'/>
			</div>

			<span class='label'>Номер лп выдела</span>
			<custom-p-input v-model='selectedSectionLp' :disabled='!selectedSection || !sectionLpExists'/>

			<span class='label'>Тип обследования</span>
			<custom-p-select
				v-model='selectedInspectionType'
				:options='inspectionTypeList'
			/>
		</div>

	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex';

	export default {
		name: 'AddressPickerBlock',
		data() {
			return {
			}
		},
		computed: {
			stateAddress() {
				return this.$store.state.createLpo.address;
			},

			selectedFo: {
				get() { return this.stateAddress.selectedFo; },
				set(value) { this.selectFo(value); }
			},
			selectedRegion: {
				get() { return this.stateAddress.selectedRegion; },
				set(value) { this.selectRegion(value); }
			},
			selectedForestry: {
				get() { return this.stateAddress.selectedForestry; },
				set(value) { this.selectForestry(value); }
			},
			selectedLocalforestry: {
				get() { return this.stateAddress.selectedLocalforestry; },
				set(value) { this.selectLocalforestry(value); }
			},
			selectedSubforestry: {
				get() { return this.stateAddress.selectedSubforestry; },
				set(value) { this.selectSubforestry(value); }
			},
			selectedArea: {
				get() { return this.stateAddress.selectedArea; },
				set(value) { this.selectArea(value); }
			},
			selectedSection: {
				get() { return this.stateAddress.selectedSection; },
				set(value) { this.selectSection(value); }
			},

			sectionLpExists: {
				get() { return this.stateAddress.sectionLpExists; },
				set(value) { this.setSectionLpExists(value); }
			},
			selectedSectionLp: {
				get() { return this.stateAddress.selectedSectionLp; },
				set(value) { this.selectSectionLp(value); }
			},
			selectedInspectionType: {
				get() { return this.stateAddress.selectedInspectionType; },
				set(value) { 
					this.selectInspectionType(value); 
				}
			},

			...mapState('createLpo/address', {
				foList: state => state.foList,
				regionList: state => state.regionList,
				forestryList: state => state.forestryList,
				localforestryList: state => state.localforestryList,
				subforestryList: state => state.subforestryList,
				areaList: state => state.areaList,
				sectionList: state => state.sectionList,
			

				loadingFoList: state => state.loadingFoList,
				loadingRegionList: state => state.loadingRegionList,
				loadingForestryList: state => state.loadingForestryList,
				loadingLocalforestryList: state => state.loadingLocalforestryList,
				loadingSubforestryList: state => state.loadingSubforestryList,
				loadingAreaList: state => state.loadingAreaList,
				loadingSectionList: state => state.loadingSectionList,
			}),

			...mapState('createLpo', {
				multipleList: state => state.multipleList,
			}),
			...mapState('selectedLpo', {
				inspectionTypeList: state => state.inspectionTypeList,
			}),

		},
		methods: {

			linkToTax() {
				const route_obj = {
					name: 'tax-info',
					params: {
						from_create: true,

						fo: this.selectedFo,
						region: this.selectedRegion,
						forestry: this.selectedForestry,
						localforestry: this.selectedLocalforestry,
						subforestry: this.selectedSubforestry,
						area: this.selectedArea,
					}
				};
				this.$router.push(route_obj);
			},

			...mapMutations('createLpo/address', [
				'setSectionLpExists'
			]),

			...mapActions('createLpo/address', [
				'selectFo',
				'selectRegion',
				'selectForestry',
				'selectLocalforestry',
				'selectLocalforestryGoFromLpo',
				'selectSubforestry',
				'selectArea',
				'selectSection',
				'selectSectionLp',
				'selectInspectionType',
				'getFoList'
			]),
			...mapActions("selectedLpo", ["getInspectionTypeList"])
		},

		created() {
			/* ставим значение по умолчанию, если ничего не выбрано */
			if (!this.selectedFo) {
				this.getFoList();
				this.selectFo({ id: '1', name: 'Центральный федеральный округ' });
				this.selectRegion({ id: '50', name: 'Московская область' });
			}

			const params = this.$route.params;

			if (params['from_tax']) {
				this.selectFo(params['fo']);
				this.selectRegion(params['region']);
				this.selectForestry(params['forestry']);
				this.selectLocalforestryGoFromLpo(params['localforestry']);
				// this.selectLocalforestry(params['localforestry']);
				this.selectSubforestry(params['subforestry']);
				this.selectArea(params['area']);
				this.selectSection(params['section']);
				// this.setSelectedSection(params['section']);
			}
			if(this.inspectionTypeList.length === 0) {
				this.getInspectionTypeList();
			}
		}

	};
</script>

<!-- <style scoped src='@/style/grid.css'></style> -->

<style scoped>
	.grid {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-gap: 0.5rem;
		align-items: center;
	}

	.label {
		font-weight: bold;
	}

	.linkToTax {
		text-decoration: underline;
		cursor: pointer;
		color: blue;
	}
	.linkToTax:hover {
		color: darkblue;
	}
</style>